import { string } from '~/prix'
import defineGeoSyncFetchAction from '../shared/geoSyncFetchDefinition'
import geoSyncFetchAction from './geoSyncFetch.action.json' assert { type: 'json' }

const geoSyncFetchDefinition = defineGeoSyncFetchAction(geoSyncFetchAction, {
  entity: string(),
})

export default geoSyncFetchDefinition
